import React from 'react';
import './Map.scss';
import {Map, Popup, ScaleControl} from 'react-map-gl';
import {
  IMapProps,
  MAPBOX_ACCESS_TOKEN,
  MAPBOX_STYLE_TOKEN,
  INITIAL_VIEW_STATE,
  DeckGLOverlay,
} from './MapHelper';
import 'mapbox-gl/dist/mapbox-gl.css';
import { PointPopup } from './Control/Popup';
import mapboxgl from 'mapbox-gl';
import useMapStore from "../../../store/mapStore";
import {useMarkerStore} from "../../../store/markerStore";
import {useMapInteractions} from "./hooks/useMapInteractions";
import {usePointStore} from "../../../store/pointStore";
import {useMapViewport} from "./hooks/useMapViewport";
import Footer from "../../layout/Footer/Footer";

const MapComponent = (props: IMapProps)  => {
  const {
    popupContent,
    popupCoordinates,
    layers,
    onPopupCoordinatesChanged,
    onClosePopup,
    onClick,
  } = props;

  const dragPan = useMapStore(state => state.dragPan);
  const updatedBounds = useMapStore(state => state.updatedBounds);
  const setMapBoundsZoom = useMapStore(state => state.setMapBoundsZoom);
  const persistedZoom = useMapStore(s => s.mapBoundsZoom.zoom);
  const setPersistedViewState = useMapStore(state => state.setViewState);
  const persistedViewState = useMapStore(s => s.viewState);

  const isAddMarkerMode = useMarkerStore(state => state.isAddMarkerMode);

  const setActivePopupPoint = usePointStore(state => state.setActivePopupPoint);
  
  const {
    viewState,
    handleViewportChange,
    handleOnLoad,
    handleOnResize,
    handleZoomPan,
  } = useMapViewport({
    initialViewState: { 
      ...INITIAL_VIEW_STATE, 
      longitude: persistedViewState.longitude ?? INITIAL_VIEW_STATE.longitude, 
      latitude: persistedViewState.latitude ?? INITIAL_VIEW_STATE.latitude, 
      zoom: persistedViewState.zoom ?? INITIAL_VIEW_STATE.zoom 
    },
    setPersistedViewState,
    setMapBoundsZoom,
    updatedBounds
  });

  const {
    hoverInfoActivePoint,
    handleMouseMove,
    mouseCoords,
    handleHover,
    handleClick,
    getCursor,
  } = useMapInteractions({
    setActivePopupPoint,
    onPopupCoordinatesChanged,
    dragPan,
    isAddMarkerMode,
  });

  return (
    <div className={ isAddMarkerMode ? 'map-container adding-marker' : 'map-container' }>
      <Map
        key="map"
        antialias
        renderWorldCopies
        mapLib={mapboxgl as any}
        mapboxAccessToken={MAPBOX_ACCESS_TOKEN}
        mapStyle={MAPBOX_STYLE_TOKEN}
        dragPan={dragPan}
        onMove={handleViewportChange}
        onMouseMove={handleMouseMove}
        onZoomEnd={handleZoomPan}
        onDragEnd={handleZoomPan}
        onLoad={handleOnLoad}
        onResize={handleOnResize}
        pitchWithRotate={false}
        style={{ position: 'fixed', width: '100vw', height: '100vh' }}
        {...viewState}
      >
        <DeckGLOverlay
          layers={[...layers]}
          interleaved={true}
          getCursor={getCursor}
          onHover={handleHover}
          onClick={(info: any, ev: any) => handleClick(info, ev, mouseCoords, onClick, isAddMarkerMode)}
        />
        {popupContent && popupCoordinates !== null &&
          <PointPopup popup={{ coordinates: popupCoordinates, onClose: onClosePopup }}>
            {popupContent}
          </PointPopup>
        }
        <ScaleControl
          unit="metric"
          maxWidth={150}
          style={{pointerEvents: 'none'}}
        />
        {hoverInfoActivePoint && (
          <Popup
            longitude={hoverInfoActivePoint?.coordinates?.[0]}
            latitude={hoverInfoActivePoint?.coordinates?.[1]}
            closeButton={false}
            anchor="top"
            offset={30}
          >
           <div>Click and hold to move point</div>
          </Popup>
        )}
      </Map>

      <Footer mouseCoords={mouseCoords} />
    </div>
  );
}

export default MapComponent;
